import SpotlightCards from '@/components/ui/SpotlightCards';
import SectionHeading from '@/components/site/SectionHeading';

export default function WhyChooseUs({ eyebrow, title, items }) {
  return (
    <section className="py-16 sm:py-24">
      <div className="site-container">
        <SectionHeading eyebrow={eyebrow} title={title} align="center" />
        <SpotlightCards className="mt-14" items={items} />
      </div>
    </section>
  );
}
